const initState = [];

const dataReducer = (state = initState, action) =>  {
    return state;
}

export default dataReducer